<template>
  <a-modal
      title="修改密码"
      :width="500"
      :visible="visible"
      :confirmLoading="false"
      @ok="() => { $emit('ok') }"
      @cancel="() => { $emit('cancel') }"
  >
    <a-form :form="form" :label-col="{span:6}" :wrapper-col="{span:15}" autoComplete="off">
      <a-form-item label="旧密码">
        <a-input
          type="password"
          v-decorator="['oldPassword', {rules: [
            {required: true, message: '必填，不能为空'}
          ]}]"
        />
      </a-form-item>
      <a-form-item label="新密码">
        <a-input
          type="password"
          v-decorator="['password', {rules: [
            {required: true, message: '必填，不能为空'}
          ]}]"
        />
      </a-form-item>
      <a-form-item label="重复新密码">
        <a-input
          type="password"
          v-decorator="['repeatPassword', {rules: [
            {required: true, message: '必填，不能为空'}
          ]}]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      form: this.$form.createForm(this)
    }
  }
}
</script>

<style scoped>

</style>
